module.exports = __webpack_public_path__ + "img/cancelled.28e910e2.svg";